// Lightweight CSV (no deps) + optional XLSX via dynamic import (keeps bundle small)
const escapeCsv = (val) => {
    if (val === null || val === undefined) return "";
    const s = String(val);
    const needsWrap = /[",\n]/.test(s);
    const escaped = s.replace(/"/g, '""');
    return needsWrap ? `"${escaped}"` : escaped;
  };
  
  export function downloadBlob(data, filename, type) {
    const blob = new Blob([data], { type });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }
  
  export function exportToCsv({ rows, columns, filename = "export.csv" }) {
    // columns: [{ key, header, render?: (value, row) => any }]
    const headers = columns.map(c => c.header ?? c.key);
    const lines = [];
    lines.push(headers.map(escapeCsv).join(","));
    for (const row of rows) {
      const line = columns.map(c => {
        const raw = c.render ? c.render(row[c.key], row) : row[c.key];
        return escapeCsv(raw);
      }).join(",");
      lines.push(line);
    }
    downloadBlob(lines.join("\n"), filename, "text/csv;charset=utf-8;");
  }
  
  export async function exportToXlsx({ rows, columns, sheetName = "Data", filename = "export.xlsx" }) {
    // Optional: npm i xlsx
    const XLSX = await import("xlsx");
    const aoa = [
      columns.map(c => c.header ?? c.key),
      ...rows.map(r => columns.map(c => (c.render ? c.render(r[c.key], r) : r[c.key]))),
    ];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, filename);
  }
  